import React from 'react';

function WriteComment({ size, strokeWidth, stroke, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
        d="M31.5 16.3125V3.9375H1.125V24.1875H9V29.7563L15.075 24.1875H22.4438"
      />
      <path
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
        d="M19.2375 27.3938L23.175 31.3313M30.9375 15.75L19.2375 27.3938L16.7625 33.75L23.175 31.3313L34.8749 19.6875L30.9375 15.75Z"
      />
    </svg>
  );
}

export default WriteComment;
